<div class="chart-title">Areas of Work as % of Remaining 20-Year Capital Needs</div>
<div class="chart-container">
    <canvas  id="pieChart" >{{ pieChart }}</canvas>
</div>
<div><app-legends-color [legendCollection]="chartLegends"></app-legends-color></div>